import React from "react";
import styled from "styled-components";
import ListLine from "organization/components/ListLine";
import { AlignmentSimple } from "components/Alignment";
import { Column } from "organization/ContractWizard/components/Column.js";

const DetailsWrapper = styled(AlignmentSimple)`
  margin: 20px;
`;

export const DeveloperPackDetails = () => (
  <DetailsWrapper vertical="center" direction="column">
    <Column.Left>
      <ListLine>3 Hosts & 6 Containers</ListLine>
      <ListLine>5 Traces per minute​</ListLine>
      <ListLine>100 Metrics</ListLine>
      <ListLine negative>NO APM transaction metrics</ListLine>
    </Column.Left>
  </DetailsWrapper>
);
